<api-call-gate [apiCall]="systemDetails">
  <ng-template #lastSuccessfulData>
    @switch (true) {
      @case (isDefault$ | async) {
        <app-component-overview [systemDetails]="systemDetails$ | async">
        </app-component-overview>
      }
      @case (isMI$ | async) {
        <app-mi-applications
          [modalityId]="modalityId$ | async"
          [systemDetails]="systemDetails$ | async"
        >
        </app-mi-applications>
        <app-mi-applications [modalityId]="modalityId$ | async">
        </app-mi-applications>
      }
      @case (isAtNeoCor$ | async) {
        <app-at-neocor-applications> </app-at-neocor-applications>
      }
      @case (isMyCoro$ | async) {
        <app-at-neocor-applications> </app-at-neocor-applications>
      }
    }
  </ng-template>
</api-call-gate>
